import React from 'react';
import PropTypes from 'prop-types';
import PublishSubmitMenuModal from './PublishSubmitMenuModal';

const PublishMenuModal = ({ modalData, setModalData, fromMoreActions }) => {
  return (
    <PublishSubmitMenuModal
      title={'Publish Assignment as a Public Assignment'}
      isOpen={modalData}
      onClose={setModalData}
      textboxLabel={'Name for the Public Assignment'}
      apiParamOptions={0}
      confirmationMsg={
        'Are you sure that you want to make this assignment public for all teachers in your district to use?'
      }
      fromMoreActions={fromMoreActions}
      helpText='To publish your assignment as a Public Assignment, accessible to all teachers in your school district, please specify a name for the Public Set, then click the Publish button.'
    />
  );
};

PublishMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func
};

export default PublishMenuModal;
